import React from 'react';
import moment from 'moment';

import {
  DECLARATION_FIELDS,
  DeclarationFieldId,
  DeclarationFieldValues,
  DeclarationTemplate,
  templateSegments,
} from 'services/declaration_templates';

interface DeclarationTemplateDocumentProps {
  template: DeclarationTemplate;
  valores: DeclarationFieldValues;
  componentRef: React.RefObject<HTMLDivElement>;
}

const VAZIO = '_________';

// Renderização do Gerador de declarações a partir da fonte única: valores em negrito, "_________"
// nos vazios, a data do dia e a linha de assinatura. `id="documento"` e o ref servem ao "Copiar
// conteúdo" e ao "Imprimir".
const DeclarationTemplateDocument: React.FC<DeclarationTemplateDocumentProps> = ({
  template,
  valores,
  componentRef,
}) => {
  const dataAtual = moment().format('LL');
  const valor = (id: DeclarationFieldId) => (valores[id] ?? '').trim() || VAZIO;

  const campo = (id: DeclarationFieldId) => (
    <span className={`${DECLARATION_FIELDS[id].classe} font-weight-bold`}>
      <span className="texto">{valor(id)}</span>
    </span>
  );

  return (
    <div className="p-5" id="documento" ref={componentRef}>
      <p className="text-center">
        <strong>{template.titulo}</strong>
      </p>
      <p className="my-5">Ref.: {campo('edital')}</p>
      <p className="my-5 text-justify">
        {templateSegments(template.qualificacao).map((segmento, index) =>
          'campo' in segmento ? (
            // eslint-disable-next-line react/no-array-index-key
            <React.Fragment key={index}>{campo(segmento.campo)}</React.Fragment>
          ) : (
            // eslint-disable-next-line react/no-array-index-key
            <React.Fragment key={index}>{segmento.texto}</React.Fragment>
          ),
        )}
      </p>
      {template.ressalva && <p className="my-5 text-left text-danger">{template.ressalva}</p>}
      {template.itens && (
        <ol type="I">
          {template.itens.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ol>
      )}
      <span className="cidade">
        <span className="texto">{valor('cidade')}</span>
      </span>
      , {dataAtual}
      <p className="p-0 mt-5">_______________________________________</p>
      {campo('representante_nome')}{' '}
      <span className="cargo font-weight-bold">
        - <span className="texto">{valor('representante_cargo')}</span>
      </span>
    </div>
  );
};

export default DeclarationTemplateDocument;
